import useHTTPInterceptor from '../hooks/use-http-interceptor';
import { useVersionCheck } from '../hooks/use-version-check';
import { VersionUpdateDialog } from './version-update-dialog';

const HttpInterceptor = () => {
  useHTTPInterceptor();
  const { showDialog, serverVersion, dismiss, update } = useVersionCheck();

  return (
    <VersionUpdateDialog
      open={showDialog}
      serverVersion={serverVersion}
      onDismiss={dismiss}
      onUpdate={update}
    />
  );
};

export default HttpInterceptor;
